import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../../icons/Icon';
import { reduxForm, propTypes as formPropTypes } from 'redux-form';
import numeral from 'numeral';

class SessionRequestConfirmationForm extends Component {
  static propTypes = {
    ...formPropTypes,
    source: PropTypes.object.isRequired,
    price: PropTypes.string.isRequired,
    hours: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
  };

  render() {
    const { source, initialValues, handleSubmit, onCancel, submitting } = this.props;

    const price = numeral(this.props.hours * this.props.price / 100).format('$0,0')
    const hourlyPrice = numeral(this.props.price / 100).format('$0,0')

    return (
      <div className="ms__request__confirm">
        <div className="request-details">
          <Icon icon="Money" />
          <h3>Confirm Follow-Up Purchase</h3>
          {initialValues.note && <i>"{initialValues.note}"</i>}
          <ul>
            {initialValues.requestedDates.map((value, index) => (
              <li key={`listitem-${index}`}>
                {index + 1}. {value.date.format('L')} @ {value.time}
              </li>
            ))}
          </ul>
        </div>
        <div className="modal__content">
          <p>
            Upon acceptance of your follow-up, your <span className="card-type">{source.get('brand')}</span> ending in{' '}
            <strong>{source.get('last4')}</strong> will be charged <em>{hourlyPrice} per hour ({price}) </em>
          </p>
        </div>
        <div className="modal-form__wrapper">
          <form onSubmit={handleSubmit}>
            <div className="modal__actions">
              <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
                Back
              </button>
              <button type="submit" className="button" disabled={submitting}>
                Confirm Purchase
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default reduxForm({
  form: 'sessionRequestForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(SessionRequestConfirmationForm);



// WEBPACK FOOTER //
// ./src/common/components/session-requests/SessionRequestConfirmationForm.js